/**
 * Technical Roles Constants
 * Contains all constants specific to technical roles management feature
 */

export const ROLE_LABELS = {
  SAVE_INFO: 'Guardar Información',
  SAVE_DRAFT: 'Guardar borrador',
  EDIT_HEADING: 'Edición del rol',
  VIEW_HEADING: 'Detalle del rol',
} as const;

export const ROLE_TEXTS = {
  roleBadge: 'Rol',
  subtitleInfo: 'Información general del rol:',
  generalInfo:
    'Agrega la información clave del rol para definir su propósito y alcance en Pragma.',
  chapterTitle: 'Chapter',
  specialtyTitle: 'Especialidad del rol',
  selectPlaceholder: 'Selecciona',
  descriptionTitle: 'Descripción general del rol',
  descriptionRol:
    'Esta descripción ayudará a otras personas a entender el propósito del rol.',
  descriptionRolPlaceholder:
    '¿Cuál es el objetivo principal de este rol? ¿Qué impacto tiene en los proyectos?',
  mainFocusTitle: 'Enfoque principal',
  descriptionMainFocus: 'Añade enfoques claves que diferencian este rol.',
  extensionMainFocus: '(Especialidad principal / Tecnología principal)',
  profileTitle: 'Perfil profesional',
  profileDescription:
    '¿Qué tipo de experiencia se espera de la persona que ocupará este rol?',
  profileTextHelp: '¿Qué es el perfil profesional?',
  equivalentRoleTitle: 'Rol equivalente en el medio',
  equivalentDescriptionText:
    'Nos ayuda a comparar este rol con estándares del mercado.',
  extensionRoleEquivalent: '¿Qué es el rol equivalente en el medio?',
  helperText: '*Puedes agregar todos los que requieras',
  chapterDescription: 'Selecciona el chapter al que pertenecerá este rol.',
  specialtyDescription:
    'Usa un nombre claro y específico. Este será visible para otros equipos.',
  titleDescriptionRol: 'Descripción del rol',
  titleDescriptionRolPragma: 'en Pragma',
  equivalentRoleTitleDescription: 'Rol equivalente en el medio / cliente',
  roleApproachesTitle: 'Enfoques del rol',
  valueTitle: 'Valor diferencial en Pragma',
  noValueLead: 'No hay valor diferencial registrado',
  teamPragmapowers: 'Team Pragmapowers',
  noTeamPragmapowers: 'No hay Team pragmapowers registrados',
  missionsTitle: 'Principales misiones en el rol',
  missionsLead:
    'Definen el impacto que se espera del rol y los retos que impulsan su crecimiento.',
  noMissions: 'No hay misiones registradas',
  technicalPragmapowers: 'Technical Pragmapowers',
  noTechnicalPragmapowers: 'No hay Technical pragmapowers registrados',
  toolsTitle: 'Herramientas del enfoque',
  noTools: 'No hay herramientas registradas',
  noExperience: 'No hay  experiencia registrada',
  reviewNoticeTitle: 'Revisa y confirma la edición del rol:',
  reviewNoticeDescription:
    'Revisa la información y confirma los cambios. Al actualizar, se reflejarán en el catálogo y en las asignaciones.',
  emptyDescriptionGeneral: 'No hay descripción registrada para este rol',
  emptyProfile: 'No hay perfil profesional registrado',
  emptyRoles: 'No hay roles equivalentes registrados',
  emptyFocus: 'No hay enfoques registrados',
  descripcionPasoDos:
    'Define el rol según cada nivel de seniority. Especifica la experiencia, el valor diferencial y los comportamientos que distinguen a cada etapa.',
  experienceCardName: 'Años de experiencia',
  experienceCardDescription:
    'Indica la experiencia mínima (en años) que suele tener un pragmático para alcanzar este nivel.',
  diferentialValueCardName: 'Valor diferencial en Pragma',
  diferentialValueCardDesc:
    'Define un texto claro y conciso sobre el impacto o propósito del rol en este nivel.',
  diferentialValuePlaceholder:
    '¿Cuál es el objetivo principal de este rol? ¿Qué impacto tiene en los proyectos?',
  emptyChapter: 'No hay chapter disponible',
  experienceRoleTitle: 'Experiencia en el rol',
  roleName: 'Nombre del rol',
};

export const BEHAVIOR_EDITOR_TEXTS = {
  originalDescriptionLabel: '*Descripción original',
  textAreaPlaceholder: 'Agrega una descripción',
  keepOriginalButton: 'Mantener descripción original',
  saveNewDescriptionButton: 'Guardar nueva descripción',
  defaultTextAreaLabel:
    'Agrega una descripción personalizada para este comportamiento en este rol',
};

export const ROLE_STEPS = [
  { path: 'general-information', label: 'Información general' },
  { path: 'seniority-info', label: 'Información por seniority' },
  { path: 'rol-confirmation', label: 'Confirmación del Rol' },
];

export const APP_PATHS = {
  TECHNICAL_ROLES: '/technical-roles',
  ROLES_CATALOG: '/technical-roles/roles-catalog',
};

export const CONFIRMATION_ROL = {
  errors: {
    invalidQueryParam: 'chapterSpecialityId inválido o ausente en query params',
    loadRoleInfo: 'Error cargando información de rol',
    loadSeniorities: 'Error al traer seniorities',
    missions: 'Error al cargar misiones',
    technical: 'Error al cargar pragmapowers técnicos',
    teamMap: 'Error al mapear pragmapowers de equipo',
    tools: 'Error al cargar herramientas',
    pragmapowerById: 'Failed to fetch name for ID',
  },
  common: {
    noAplica: 'No aplica',
    year: 'año',
    years: 'años',
  },
} as const;

export const DEFAULT_CHAPTER = {
  LABEL: 'Frontend',
  VALUE: 17,
} as const;

export const ROLE_ACTIONS = {
  edit: {
    label: 'Editar rol',
    icon: 'assets/icons/edit-white.svg',
    action: 'edit' as const,
  },
  view: {
    label: 'Ver rol',
    icon: 'assets/icons/eye-white.svg',
    action: 'view' as const,
  },
};

export const ROLES_UI_LABELS = {
  Role: 'Rol',
  Focus: 'Enfoque',
  EditMap: 'Editar mapa',
} as const;
